import React from 'react';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@auth/hooks';
import LoginView from '../views/LoginView/LoginView';
import AuthView from '../views/AuthView/AuthView';

export default function () {
  const { user } = useAuth();

  return (
    <AuthView>
      <Outlet />
      <Routes>
        <Route
          index
          path="login"
          element={user ? <Navigate to="/dashboard/*" /> : <LoginView />}
        />
        <Route
          path="*"
          index
          element={<Navigate to={user ? '/dashboard/*' : 'login'} replace />}
        />
      </Routes>
    </AuthView>
  );
}
